// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__29Mul","list":"BalanceDue_list__3t5fS","listRow":"BalanceDue_listRow__uooRa","total":"BalanceDue_total__2dLB2"};